import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GrocyCacheApi } from '../../../../../core/api/grocy/cache.api';
import { GrocyContextDataApi } from '../../../../../core/api/grocy/context-data.api';
import { GrocyQuickActionDialogComponent } from '../quick-action-dialog/quick-action-dialog.component';
import { GrocyRegisterShoppingDialogComponent } from '../register-shopping-dialog/register-shopping-dialog.component';
import { GrocyStockLookupDialogComponent } from '../stock-lookup-dialog/stock-lookup-dialog.component';

@Component({
  selector: 'app-grocy-actions',
  templateUrl: './actions.component.html',
  styleUrl: './actions.component.scss',
})
export class GrocyActionsComponent {
  constructor(
    private cacheApi: GrocyCacheApi,
    private contextDataApi: GrocyContextDataApi,
    private dialog: MatDialog
  ) {}

  openQuickActionDialog(): void {
    this.dialog.open(GrocyQuickActionDialogComponent, { width: '1600px' });
  }

  openRegisterShoppingDialog(): void {
    this.dialog.open(GrocyRegisterShoppingDialogComponent, { width: '1600px' });
  }

  openStockLookupDialog(): void {
    this.dialog.open(GrocyStockLookupDialogComponent, { width: '1600px' });
  }

  refreshCache(): void {
    this.cacheApi.refresh().subscribe(() => this.contextDataApi.refresh());
  }
}
